// RBAC Permission Constants
// These match the backend permission structure

export const PERMISSIONS = {
  // Users Module
  USERS_VIEW: "Users.View",
  USERS_CREATE: "Users.Create",
  USERS_EDIT: "Users.Edit",
  USERS_DELETE: "Users.Delete",

  // Contents Module
  CONTENTS_VIEW: "Contents.View",
  CONTENTS_UPLOAD: "Contents.Upload",
  CONTENTS_PUBLISH: "Contents.Publish",
  CONTENTS_DELETE: "Contents.Delete",

  // Courses Module
  COURSES_VIEW: "Courses.View",
  COURSES_CREATE: "Courses.Create",
  COURSES_EDIT: "Courses.Edit",
  COURSES_DELETE: "Courses.Delete",

  // Packages Module
  PACKAGES_VIEW: "Packages.View",
  PACKAGES_CREATE: "Packages.Create",
  PACKAGES_EDIT: "Packages.Edit",
  PACKAGES_DELETE: "Packages.Delete",

  // Exams Module
  EXAMS_VIEW: "Exams.View",
  EXAMS_CREATE: "Exams.Create",
  EXAMS_EDIT: "Exams.Edit",
  EXAMS_DELETE: "Exams.Delete",

  // Questions Module
  QUESTIONS_VIEW: "Questions.View",
  QUESTIONS_CREATE: "Questions.Create",
  QUESTIONS_EDIT: "Questions.Edit",
  QUESTIONS_DELETE: "Questions.Delete",

  // Reports Module
  REPORTS_VIEW: "Reports.View",
  REPORTS_EXPORT: "Reports.Export",

  // Roles Module
  ROLES_VIEW: "Roles.View",
  ROLES_CREATE: "Roles.Create",
  ROLES_EDIT: "Roles.Edit",
  ROLES_DELETE: "Roles.Delete",
  ROLES_ASSIGN: "Roles.Assign",

  // ExamBanks Module
  EXAMBANKS_VIEW: "ExamBanks.View",
  EXAMBANKS_CREATE: "ExamBanks.Create",
  EXAMBANKS_EDIT: "ExamBanks.Edit",
  EXAMBANKS_DELETE: "ExamBanks.Delete",

  // Activity Logs Module
  LOGS_VIEW: "Logs.View",

  // Database backups
  BACKUPS_VIEW: "Backups.View",
  BACKUPS_DOWNLOAD: "Backups.Download",
};

// Permission Groups for easier management
export const PERMISSION_GROUPS = {
  Users: [
    { key: PERMISSIONS.USERS_VIEW, label: "مشاهده کاربران" },
    { key: PERMISSIONS.USERS_CREATE, label: "ایجاد کاربر" },
    { key: PERMISSIONS.USERS_EDIT, label: "ویرایش کاربر" },
    { key: PERMISSIONS.USERS_DELETE, label: "حذف کاربر" },
  ],
  Contents: [
    { key: PERMISSIONS.CONTENTS_VIEW, label: "مشاهده محتوا" },
    { key: PERMISSIONS.CONTENTS_UPLOAD, label: "آپلود محتوا" },
    { key: PERMISSIONS.CONTENTS_PUBLISH, label: "انتشار محتوا" },
    { key: PERMISSIONS.CONTENTS_DELETE, label: "حذف محتوا" },
  ],
  Courses: [
    { key: PERMISSIONS.COURSES_VIEW, label: "مشاهده و انتشار دوره‌ها" },
    { key: PERMISSIONS.COURSES_CREATE, label: "ایجاد دوره" },
    { key: PERMISSIONS.COURSES_EDIT, label: "ویرایش دوره" },
    { key: PERMISSIONS.COURSES_DELETE, label: "حذف دوره" },
  ],
  Packages: [
    { key: PERMISSIONS.PACKAGES_VIEW, label: "مشاهده پکیج‌ها" },
    { key: PERMISSIONS.PACKAGES_CREATE, label: "ایجاد پکیج" },
    { key: PERMISSIONS.PACKAGES_EDIT, label: "ویرایش پکیج" },
    { key: PERMISSIONS.PACKAGES_DELETE, label: "حذف پکیج" },
  ],
  Exams: [
    { key: PERMISSIONS.EXAMS_VIEW, label: "مشاهده آزمون‌ها" },
    { key: PERMISSIONS.EXAMS_CREATE, label: "ایجاد آزمون" },
    { key: PERMISSIONS.EXAMS_EDIT, label: "ویرایش آزمون" },
    { key: PERMISSIONS.EXAMS_DELETE, label: "حذف آزمون" },
  ],
  Questions: [
    { key: PERMISSIONS.QUESTIONS_VIEW, label: "مشاهده سوالات" },
    { key: PERMISSIONS.QUESTIONS_CREATE, label: "ایجاد سوال" },
    { key: PERMISSIONS.QUESTIONS_EDIT, label: "ویرایش سوال" },
    { key: PERMISSIONS.QUESTIONS_DELETE, label: "حذف سوال" },
  ],
  Reports: [
    { key: PERMISSIONS.REPORTS_VIEW, label: "مشاهده گزارش‌ها" },
    { key: PERMISSIONS.REPORTS_EXPORT, label: "خروجی گزارش‌ها" },
  ],
  Roles: [
    { key: PERMISSIONS.ROLES_VIEW, label: "مشاهده نقش‌ها" },
    { key: PERMISSIONS.ROLES_CREATE, label: "ایجاد نقش" },
    { key: PERMISSIONS.ROLES_EDIT, label: "ویرایش نقش" },
    { key: PERMISSIONS.ROLES_DELETE, label: "حذف نقش" },
    { key: PERMISSIONS.ROLES_ASSIGN, label: "تخصیص نقش" },
  ],
  ExamBanks: [
    { key: PERMISSIONS.EXAMBANKS_VIEW, label: "مشاهده بانک آزمون" },
    { key: PERMISSIONS.EXAMBANKS_CREATE, label: "ایجاد بانک آزمون" },
    { key: PERMISSIONS.EXAMBANKS_EDIT, label: "ویرایش بانک آزمون" },
    { key: PERMISSIONS.EXAMBANKS_DELETE, label: "حذف بانک آزمون" },
  ],
  Logs: [
    { key: PERMISSIONS.LOGS_VIEW, label: "مشاهده گزارش فعالیت‌ها" },
  ],
  Backups: [
    { key: PERMISSIONS.BACKUPS_VIEW, label: "مشاهده پشتیبان پایگاه داده" },
    { key: PERMISSIONS.BACKUPS_DOWNLOAD, label: "دانلود پشتیبان پایگاه داده" },
  ],
};

export const PERMISSION_MODULE_NAMES = {
  Users: "کاربران",
  Contents: "محتوا",
  Courses: "دوره‌ها",
  Packages: "پکیج‌ها",
  Exams: "آزمون‌ها",
  Questions: "سوالات",
  Reports: "گزارش‌ها",
  Roles: "نقش‌ها",
  ExamBanks: "بانک آزمون",
  Logs: "گزارش فعالیت‌ها",
  Backups: "پشتیبان پایگاه داده",
};
